import React from "react";
import our from "../img/Biz kimiz foto.jpg";
import LanguageApi from "../components/Language";
const Our = () => {
  const {who_are_we, who_are_we_text} = LanguageApi();
  return (
    <div className="corporate">
      <div className="corporate-img">
        <img src={our} alt="corporate" />
      </div>
      <div className="corporate-head">
        <div className="corporate-head-in">
          <h1>{who_are_we}</h1>
        </div>
      </div>
      <div className="corporate-body">
        <div className="corporate-body-in"  dangerouslySetInnerHTML={{__html: who_are_we_text}}>
        </div>
      </div>
    </div>
  );
};

export default Our;
